import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import api from '../../services/api';

const initialState = {
  DashboardData: null,
};

export const dashboard = createAsyncThunk('auth/dashboard', async () => {
  try {
    const response = await api({
      baseURL: process.env.REACT_APP_API_BASE_URL,
      url: '/dashboard/',
      method: 'GET',
    });
    return response?.data;
  } catch (error) {
    console.log(error);
    return '';
  }
});
export const getFeesSumary = createAsyncThunk(
  'getFeesSumary',
  async (data, { rejectWithValue }) => {
    try {
      const response = await api({
        baseURL: process.env.REACT_APP_API_BASE_URL,
        url: '/dashboard/fees',
        method: 'GET',
        headers: { ...data, classesName: data?.className },
      });
      return response?.data;
    } catch (error) {
      console.log(error);
      return rejectWithValue('');
    }
  },
);
export const getMonthlyFees = createAsyncThunk(
  'getMontlyFees',
  async (month, { rejectWithValue }) => {
    try {
      const response = await api({
        baseURL: process.env.REACT_APP_API_BASE_URL,
        url: `/dashboard/monthly-summary?month=${month}`,
        method: 'GET',
      });
      return response?.data;
    } catch (error) {
      console.log(error);
      return rejectWithValue('');
    }
  },
);
export const getOtherFeesSumary = createAsyncThunk(
  'getOtherFeesSumary',
  async (data, { rejectWithValue }) => {
    try {
      const response = await api({
        baseURL: process.env.REACT_APP_API_BASE_URL,
        url: '/dashboard/otherFees',
        method: 'GET',
        headers: { ...data, classesName: data?.className },
      });
      return response?.data;
    } catch (error) {
      console.log(error);
      return rejectWithValue('');
    }
  },
);
export const getParticularFee = createAsyncThunk(
  'getParticularFee',
  async (id, { rejectWithValue }) => {
    try {
      const response = await api({
        baseURL: process.env.REACT_APP_API_BASE_URL,
        url: `/dashboard/feeType/${id}`,
        method: 'GET',
      });
      return response?.data;
    } catch (error) {
      console.log(error);
      return rejectWithValue('');
    }
  },
);
export const getAttendanceSumary = createAsyncThunk(
  'getAttendacneSumary',
  async (data, { rejectWithValue }) => {
    try {
      const response = await api({
        baseURL: process.env.REACT_APP_API_BASE_URL,
        url: '/dashboard/attendance',
        method: 'GET',
        headers: { ...data, classesName: data?.className },
      });
      return response?.data;
    } catch (error) {
      console.log(error);
      return rejectWithValue('');
    }
  },
);

export const getGenderActivity = createAsyncThunk(
  'getGenderActivity',
  async (departmentName, { rejectWithValue }) => {
    try {
      const response = await api({
        baseURL: process.env.REACT_APP_API_BASE_URL,
        url: '/dashboard/gender',
        method: 'GET',
        headers: { departmentName },
      });
      return response?.data;
    } catch (error) {
      console.log(error);
      return rejectWithValue('');
    }
  },
);
export const getExamReportsData = createAsyncThunk(
  'getExamReportsData',
  async (searchValues, { rejectWithValue }) => {
    try {
      const response = await api({
        baseURL: process.env.REACT_APP_API_BASE_URL,
        url: '/dashboard/marks',
        method: 'GET',
        headers: { ...searchValues, classesName: searchValues.className },
      });
      return response?.data;
    } catch (error) {
      console.log(error);
      return rejectWithValue('');
    }
  },
);
export const adminDashboard = createAsyncThunk(
  'auth/adminDashboard',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api({
        baseURL: process.env.REACT_APP_API_BASE_URL,
        url: '/admin/getRequests',
        method: 'GET',
      });
      return { data: response?.data, status: response.status };
    } catch (error) {
      return rejectWithValue({
        data: error?.response?.data,
        status: error?.response.status,
      });
    }
  },
);

const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState,
  extraReducers: (builder) => {
    builder

      .addCase(dashboard.fulfilled, (state, action) => {
        state.DashboardData = action.payload;
      })
      .addCase(dashboard.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default dashboardSlice.reducer;
